<template>
  <div
    class="h5-ai-search-spot"
    @click="onSearchItemClick"
  >
    <div class="h5-ai-search-spot__thumbnails">
      <Image
        v-for="product of item.product_list.slice(0, 6)"
        :key="product.offerId"
        class="h5-ai-search-spot__thumbnail"
        :src="product.image_url"
      />
    </div>
    <div class="h5-ai-search-spot__content">
      <p class="h5-ai-search-spot__text">
        AI has found the products you may need!
      </p>
      <div class="h5-ai-search-spot-result">
        <img
          src="@/assets/colorIcon/ai-search.svg"
        >
        <span class="h5-ai-search-spot-result__hint">“<span class="h5-ai-search-spot-result__keywords">{{ item.en }}</span>”</span>
      </div>
      <div class="h5-ai-search-spot__view">
        View more
        <Icon name="arrow-right-l-2" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { Icon } from '@/components/Icon'
import { openURLWithChannelQuery } from '@/utils/utils'
import { Image } from '@/components/Image'

const props = defineProps({
  item: {
    type: Object,
    required: true
  }
})

const onSearchItemClick = (item) => {
  openURLWithChannelQuery(`/search?keyword=${props.item.en}&keywordCn=${props.item.cn}&isAISearched=true`)
}
</script>

<style lang="less" scoped>
.h5-ai-search-spot {
  cursor: pointer;

  &__thumbnails {
    z-index: -1;
    position: relative;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 4px;

    &::after {
      content: '';
      position: absolute;
      right: 0;
      bottom: 0;
      left: 0;
      padding-bottom: 50%;
      background: linear-gradient(to top, #FFFFFF, #FFFFFF 50%, rgba(255, 255, 255, 0));
    }
  }

  &__thumbnail {
    width: 100%;
    aspect-ratio: 1;
    border-radius: 4px;
  }

  &__content {
    margin-top: -41px;
    padding: 8px;
  }

  &__text {
    font-family: mon-500;
    font-size: 12px;
    line-height: 16px;
    color: #5C5C5C;
  }

  &-result {
    margin-top: 4px;
    display: flex;
    align-items: center;
    gap: 4px;

    > img {
      width: 12px;
      height: 12px;
    }

    &__hint {
      font-family: mon-600;
      font-size: 14px;
      color: #232323;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &__keywords {
      text-decoration: underline;
    }
  }

  &__view {
    margin-top: 8px;
    display: flex;
    align-items: center;
    gap: 2px;
    font-family: mon-500;
    font-size: 12px;
    line-height: 16px;

    > img {
      width: 12px;
      height: 12px;
    }
  }
}
</style>
